export function ParcelIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1690_15210)">
        <path
          d="M13.1733 17.9373L19.7599 13.7722C19.7842 13.7572 19.8161 13.7637 19.8311 13.7881C19.8461 13.8125 19.8396 13.8443 19.8152 13.8593L13.207 18.0376C13.1986 18.0432 13.1892 18.046 13.1798 18.046L13.1733 17.9373Z"
          fill="url(#paint0_linear_1690_15210)"
        />
        <path
          d="M13.1798 18.0463C13.1742 18.0463 13.1677 18.0454 13.162 18.0435L4.182 14.6968C4.1756 14.6944 4.16973 14.6909 4.16474 14.6862C4.15974 14.6816 4.15573 14.676 4.15293 14.6698C4.15014 14.6636 4.14861 14.6569 4.14845 14.6501C4.14829 14.6433 4.1495 14.6365 4.152 14.6302C4.16231 14.603 4.19137 14.5899 4.21856 14.6002L13.1752 17.9376L13.1798 18.0463Z"
          fill="url(#paint1_linear_1690_15210)"
        />
        <path
          d="M22.6031 2.0448L21.5663 3.76127L17.4012 5.53221L17.1697 5.63065L13.4263 9.13108C13.3541 9.20327 13.3054 9.3064 13.2969 9.36358C13.2932 9.38327 13.2763 9.37483 13.2604 9.3739C13.2435 9.37296 13.2201 9.37952 13.2182 9.3589C13.2163 9.2839 13.2079 9.20046 13.0869 9.12546L11.2111 7.91046L9.84328 7.02358L5.99043 6.03555L2.76543 5.20868L0.722809 2.03543L0.753746 1.9998L0.755621 1.99699L8.42409 0.00386438C8.43534 0.00011438 8.43721 0.00198938 8.4419 0.00855188L11.0573 3.92627L11.1089 4.00315C11.1652 4.08565 11.1708 4.13627 11.1708 4.17283H11.2186V4.1644C11.2186 4.16065 11.2186 4.15596 11.2195 4.15127C11.2195 4.14846 11.2205 4.14565 11.2205 4.1419C11.2214 4.13815 11.2214 4.1344 11.2223 4.13065C11.2233 4.1269 11.2233 4.12315 11.2242 4.11846C11.227 4.10533 11.2308 4.09033 11.2345 4.07533C11.2355 4.07065 11.2373 4.06596 11.2383 4.06221C11.243 4.04721 11.2477 4.03127 11.2533 4.01627C11.2561 4.01065 11.258 4.00408 11.2608 3.99846C11.2683 3.97971 11.2758 3.96283 11.2842 3.94783C11.2917 3.93283 11.2992 3.92065 11.3067 3.91033L13.6645 0.481052C13.6702 0.472614 13.673 0.468864 13.6852 0.470739L22.5882 2.00261L22.6031 2.0448Z"
          fill="#E8B67F"
        />
        <path
          d="M11.2111 7.90938H11.2102L9.84337 7.02354L5.99043 6.03541L11.1708 4.1727L11.1848 4.14551V4.1727L11.2111 7.90938Z"
          fill="url(#paint2_linear_1690_15210)"
        />
        <path
          d="M11.1708 4.17275L5.99043 6.03454L5.52356 5.91454L2.76543 5.20672L0.722809 2.03347L0.755621 1.99504L8.42409 0.00191125C8.43534 -0.00183875 8.43721 3.62552e-05 8.4419 0.00659876L11.0573 3.92432L11.1089 4.00119C11.1652 4.08557 11.1708 4.13619 11.1708 4.17275Z"
          fill="url(#paint3_linear_1690_15210)"
        />
        <path
          d="M11.1891 4.37058L6.29081 6.13111L5.52675 5.93518L11.0606 3.9458L11.1122 4.02268C11.1684 4.10518 11.1741 4.1558 11.1741 4.19236H11.1881L11.1891 4.37058Z"
          fill="url(#paint4_linear_1690_15210)"
        />
        <path
          d="M2.83584 5.22522L2.76647 5.20741L0.723747 2.03416L0.754685 1.99854L2.83584 5.22522Z"
          fill="#D2A679"
        />
        <path
          d="M17.4012 5.53202L17.1697 5.63045L13.4263 9.13098C13.3541 9.20317 13.3054 9.3063 13.2969 9.36348C13.2932 9.38317 13.2763 9.37473 13.2604 9.3738C13.2435 9.37286 13.2201 9.37942 13.2182 9.3588C13.2163 9.2838 13.2079 9.20036 13.0869 9.12536L11.2111 7.90942L11.1858 4.17367V4.14648L11.2205 4.17367L17.4012 5.53202Z"
          fill="url(#paint5_linear_1690_15210)"
        />
        <path
          d="M22.6031 2.04471L21.5663 3.76118L17.7753 5.37274L17.4022 5.53118L11.2195 4.17274C11.2158 4.12493 11.2486 4.01618 11.2842 3.94681C11.2917 3.93181 11.2992 3.91962 11.3067 3.90931L13.6645 0.480024C13.6702 0.471586 13.673 0.467836 13.6852 0.469711L22.5882 2.00159L22.6031 2.04471Z"
          fill="url(#paint6_linear_1690_15210)"
        />
        <path
          d="M17.7753 5.37268L17.1706 5.62955L17.0928 5.70455L11.1848 4.39861L11.212 4.17174H11.2195C11.2158 4.12393 11.2486 4.01518 11.2842 3.9458L17.7753 5.37268Z"
          fill="url(#paint7_linear_1690_15210)"
        />
        <path
          opacity="0.75"
          d="M11.3489 4.20098V7.9986L11.2111 7.90954H11.2102L11.0292 7.79141V4.22348L11.1708 4.17285H11.2186L11.3489 4.20098Z"
          fill="url(#paint8_linear_1690_15210)"
        />
        <path
          d="M13.1433 17.9854L4.15575 14.6321C4.10512 14.6105 4.09763 14.5627 4.09481 14.5036C4.09481 14.5036 3.70856 6.84462 3.70762 6.84368C3.70669 6.82399 3.73106 6.8118 3.72919 6.79962C3.72263 6.77056 3.66731 6.66087 3.6495 6.64962L0 4.57587L0.0309375 4.50555L9.84338 7.02368L13.0861 9.12452C13.207 9.19952 13.2164 9.28296 13.2173 9.35796C13.2183 9.37859 13.2427 9.37202 13.2595 9.37296C13.2764 9.3739 13.2923 9.38234 13.2961 9.36265C13.3045 9.30546 13.3533 9.20234 13.4255 9.13109L17.1687 5.63055L23.9569 2.74512L23.9981 2.8023L20.3336 6.02252C20.2624 6.09377 20.2296 6.18096 20.2436 6.21659L19.8686 13.7229C19.863 13.7707 19.8405 13.7847 19.7927 13.8176L13.223 17.9761C13.1967 17.993 13.1686 17.9976 13.1433 17.9854Z"
          fill="#BF9064"
        />
        <path
          d="M13.2594 9.37286L13.1948 17.989C13.1773 17.9939 13.1588 17.9926 13.1423 17.9853L4.15481 14.6329C4.10419 14.6113 4.09669 14.5626 4.09388 14.5044L3.70669 6.84451V6.84264C3.70669 6.84076 3.70669 6.83889 3.70763 6.83701C3.70763 6.83514 3.70856 6.8342 3.7095 6.83326C3.71044 6.83139 3.71138 6.83045 3.71231 6.82857C3.71325 6.8267 3.71419 6.82576 3.71513 6.82389C3.71888 6.81826 3.7245 6.81264 3.72638 6.80795C3.72731 6.80701 3.72731 6.80607 3.72731 6.80514V6.8042L13.2183 9.36161C13.222 9.37848 13.2444 9.37192 13.2594 9.37286Z"
          fill="#BD8F63"
        />
        <path
          opacity="0.54"
          d="M13.1958 17.9637V17.9881C13.1784 17.993 13.1598 17.9916 13.1433 17.9843L4.15575 14.6319C4.12013 14.6169 4.10607 14.5879 4.0995 14.5522L13.1958 17.9637Z"
          fill="url(#paint9_linear_1690_15210)"
        />
        <path
          d="M9.13181 12.7373L12.6117 13.8754L12.6033 17.269L9.18806 16.0146L9.13181 12.7373ZM10.8756 15.0173L10.884 16.5894L12.5694 17.2085V15.606L10.8756 15.0173ZM11.3735 15.5251L11.7141 16.0672L12.0477 15.7749L12.1058 15.8412L11.7615 16.1428L12.1066 16.692L12.0566 16.7234L11.7165 16.1821L11.3845 16.4731L11.3264 16.4069L11.6691 16.1066L11.3235 15.5566L11.3735 15.5251ZM12.3764 16.1356V16.2903L12.4655 16.3194V16.4938L12.3764 16.4581V16.5988L12.1814 16.3025L12.3764 16.1356ZM12.0764 15.9472L12.1448 15.9688V16.5866L12.0764 16.5622V15.9472ZM9.20024 14.435L9.22556 15.9828L10.8362 16.5716L10.8268 15.0031L9.20024 14.435ZM11.7184 16.28L11.8946 16.5641L11.5431 16.4366L11.7184 16.28ZM11.9901 16.0194V16.4225L11.8073 16.1647L11.9901 16.0194ZM11.2926 15.6603L11.3601 15.6828V16.2997L11.2926 16.2763V15.6603ZM11.4445 15.8263L11.6189 16.0953L11.4445 16.2294V15.8263ZM9.98765 15.0791L10.0542 15.1006L10.0544 15.1402C10.2526 15.2199 10.4483 15.4186 10.5427 15.7278C10.4809 15.6238 10.4265 15.6041 10.3299 15.6369C10.2943 15.5628 10.1893 15.5235 10.1265 15.5628C10.1106 15.5324 10.0863 15.5072 10.0566 15.4901L10.0599 16.0785C10.0599 16.1328 10.0224 16.1816 9.92962 16.1628C9.84524 16.1422 9.81056 16.0775 9.81993 15.9669L9.86681 15.9744C9.86681 16.0485 9.87243 16.0906 9.92868 16.1038C9.97649 16.115 9.99806 16.0972 9.99806 16.0531L9.99187 15.4696C9.96524 15.4677 9.94059 15.4742 9.92306 15.4897C9.90149 15.4353 9.79931 15.3622 9.72243 15.4166C9.66806 15.3303 9.56587 15.2975 9.50868 15.3603C9.58171 15.1396 9.77999 15.0622 9.98802 15.118L9.98765 15.0791ZM11.0545 15.6538L11.2448 15.9538L11.0564 16.1103L11.0601 15.9631L10.9683 15.9416V15.771L11.0545 15.8028V15.6538ZM11.5373 15.7185L11.8936 15.8478L11.7155 16.0044L11.5373 15.7185ZM10.8726 13.356L10.8764 14.9591L12.5705 15.5497V13.9119L10.8726 13.356ZM11.1886 14.7406L12.2011 15.0866V15.2881L11.1886 14.9394V14.7406ZM10.3168 15.1231C10.3234 15.1297 10.3234 15.2 10.3018 15.216C10.2954 15.2188 10.2884 15.2199 10.2815 15.2191C10.2745 15.2183 10.2679 15.2156 10.2624 15.2113C10.2493 15.201 10.2418 15.186 10.2474 15.1635C10.2531 15.141 10.3093 15.1166 10.3168 15.1231ZM10.4106 14.9628C10.4181 14.9694 10.4181 15.0397 10.3956 15.0556C10.3892 15.0585 10.3822 15.0596 10.3752 15.0588C10.3683 15.0579 10.3617 15.0552 10.3562 15.051C10.3431 15.0406 10.3356 15.0256 10.3412 15.0031C10.3468 14.9806 10.4031 14.9563 10.4106 14.9628ZM10.1481 14.9563C10.1556 14.9628 10.1556 15.0331 10.1331 15.0491C10.1267 15.052 10.1197 15.053 10.1127 15.0522C10.1058 15.0514 10.0992 15.0487 10.0937 15.0444C10.0806 15.0341 10.0731 15.0191 10.0787 14.9966C10.0843 14.9741 10.1406 14.9497 10.1481 14.9563ZM9.88274 14.9178C9.89024 14.9244 9.89024 14.9947 9.86774 15.0106C9.86137 15.0135 9.85434 15.0146 9.8474 15.0138C9.84047 15.0129 9.83389 15.0102 9.82837 15.006C9.81524 14.9956 9.80774 14.9806 9.81337 14.9581C9.81899 14.9356 9.87524 14.9113 9.88274 14.9178ZM11.9705 13.8642L12.2161 14.3489L12.0483 14.2917V14.9939L11.8805 14.9357L11.8814 14.2392L11.7145 14.1848L11.9705 13.8642ZM9.16837 12.7973L9.19743 14.3789L10.8277 14.9395L10.8137 13.3373L9.16837 12.7973ZM11.4165 13.6795L11.6621 14.1642L11.4943 14.107V14.8092L11.3265 14.7511L11.3284 14.0545L11.1606 14.0001L11.4165 13.6795ZM9.53306 13.1151L9.66618 13.1592L9.72806 13.3832L9.65868 13.3786L9.85649 13.8567L9.75431 13.4629L9.81243 13.462L9.75337 13.1873L10.4406 13.4142V13.792C10.4406 13.9354 10.2849 14.1164 10.0656 14.0264L10.0665 14.4061L10.3815 14.6086L9.61931 14.3442L9.92587 14.3592L9.92024 13.9832C9.70274 13.9186 9.54524 13.657 9.54524 13.4976L9.53306 13.1151Z"
          fill="#322214"
        />
        <path
          d="M13.2594 9.37308C13.2219 9.37402 13.1938 9.4237 13.1929 9.4687L13.1844 9.47245L3.70669 6.8437C3.70575 6.82589 3.72638 6.81464 3.72825 6.80339C3.72919 6.80245 3.72919 6.80152 3.72825 6.80058C3.72169 6.77152 3.66637 6.66183 3.64856 6.65058L0 4.57617L0.0309375 4.50586L9.84244 7.02295H9.84338L13.0861 9.1238C13.207 9.19973 13.2164 9.28223 13.2173 9.35723C13.2173 9.35817 13.2173 9.36005 13.2183 9.36098C13.222 9.3788 13.2445 9.37223 13.2595 9.37317"
          fill="url(#paint10_linear_1690_15210)"
        />
        <path
          d="M20.3346 6.02145C20.2633 6.0927 20.2305 6.17989 20.2446 6.21552L13.3419 9.48167L13.3279 9.47042C13.3269 9.41605 13.2923 9.37948 13.266 9.37386C13.2801 9.37573 13.2932 9.38042 13.2969 9.36261C13.2988 9.35136 13.3016 9.33823 13.3063 9.32417C13.3101 9.31198 13.3157 9.29886 13.3223 9.2848C13.3419 9.2398 13.3719 9.19105 13.4104 9.14792C13.416 9.1423 13.4216 9.13573 13.4273 9.13011L17.1706 5.62958L23.9588 2.74414L24 2.80133L20.3346 6.02145Z"
          fill="#CD9C6B"
        />
        <path
          d="M8.99962 10.2314C9.00993 10.2342 9.01369 10.2351 9.01369 10.2267L8.97806 8.31989C8.97525 8.2552 8.95931 8.1277 8.8815 8.07614L5.42512 5.97623L3.80512 5.55811L7.31784 7.65717C7.40597 7.71529 7.41347 7.82404 7.41722 7.90467L7.46784 9.75886C7.46784 9.76823 7.46972 9.77011 7.47628 9.77292L8.99962 10.2314Z"
          fill="url(#paint11_linear_1690_15210)"
        />
        <path
          d="M13.2594 9.37277C13.221 9.37371 13.1929 9.42621 13.1929 9.47215C13.1919 9.4759 13.1854 9.47496 13.1844 9.47215C13.1769 9.36996 13.1347 9.25559 13.0794 9.21527L9.81056 7.10777L9.84244 7.02246H9.84337L13.0861 9.1234C13.207 9.19934 13.2164 9.28184 13.2173 9.35684C13.2173 9.35777 13.2173 9.35965 13.2183 9.36059C13.222 9.3784 13.2444 9.37184 13.2594 9.37277Z"
          fill="#D4A271"
        />
        <path
          d="M9.84244 7.02344L9.81056 7.10782L0 4.57572L0.0309375 4.50635L9.84244 7.02344Z"
          fill="#DEB37E"
        />
        <path
          d="M20.2455 6.21556L19.8705 13.7218C19.8649 13.7697 19.8424 13.7837 19.7946 13.8165L13.2248 17.9751C13.2155 17.9817 13.2052 17.9854 13.1958 17.9882L13.2605 9.37203C13.2773 9.37297 13.2933 9.38141 13.297 9.36172C13.297 9.35891 13.298 9.35703 13.298 9.35422L20.2436 6.20703C20.2436 6.21172 20.2446 6.21369 20.2455 6.21556Z"
          fill="#DBAD77"
        />
        <path
          opacity="0.54"
          d="M19.8705 13.7188V13.7225C19.8649 13.7703 19.8424 13.7844 19.7946 13.8172L13.2248 17.9757C13.2155 17.9823 13.2052 17.9861 13.1958 17.9889V17.9645L19.8705 13.7188Z"
          fill="url(#paint12_linear_1690_15210)"
        />
        <path
          d="M19.7477 10.4526L19.5977 13.5088L17.4133 14.8691L17.5258 11.6882L19.7477 10.4526ZM18.5796 12.6651L17.4939 13.3035L17.4424 14.8082L18.5233 14.136L18.5796 12.6651ZM18.0611 13.311L18.0593 13.3616C18.1889 13.2969 18.3114 13.3419 18.363 13.5566C18.3274 13.5069 18.2627 13.5266 18.2196 13.6279C18.1999 13.5857 18.0996 13.6204 18.0846 13.7085C18.0766 13.6941 18.0623 13.6889 18.0458 13.6908L18.0218 14.271C18.02 14.3207 18.0172 14.3741 17.9543 14.4125C17.9253 14.4257 17.8484 14.436 17.8587 14.3282L17.8953 14.3C17.8925 14.3685 17.9103 14.3891 17.9478 14.3666C17.9928 14.3394 17.9843 14.2963 17.9862 14.256L18.0064 13.7062C17.9918 13.7158 17.9794 13.7281 17.9696 13.7424C17.9599 13.7568 17.9531 13.773 17.9497 13.79C17.9384 13.7563 17.8297 13.7769 17.8165 13.8735C17.7856 13.8322 17.7012 13.8725 17.6693 13.9766C17.728 13.7063 17.8735 13.482 18.0184 13.3854L18.02 13.341L18.0611 13.311ZM19.6455 12.035L18.6105 12.6472L18.5533 14.1219L19.5771 13.4779L19.6455 12.035ZM19.3258 12.5319L19.3558 12.56L19.1303 13.0717L19.3164 13.3288L19.2864 13.3925L19.1008 13.1385L18.8777 13.6447L18.8468 13.6166L19.074 13.1018L18.8814 12.8385L18.9152 12.7747L19.1036 13.0349L19.3258 12.5319ZM18.6958 13.1197L18.813 13.2622L18.6883 13.5304V13.4122L18.6358 13.4441L18.6386 13.2913L18.6911 13.2604L18.6958 13.1197ZM18.8983 12.9341L18.8739 13.4994L18.8318 13.5275L18.8552 12.9641L18.8983 12.9341ZM19.0961 13.2294L19.1964 13.3616L18.9808 13.4929L19.0961 13.2294ZM17.9477 13.2707C17.9524 13.2707 17.9496 13.3354 17.9336 13.3672C17.928 13.3785 17.9177 13.3907 17.9093 13.3916C17.9008 13.3925 17.8971 13.3832 17.9018 13.3588C17.9064 13.3344 17.943 13.2707 17.9477 13.2707ZM18.9452 13.011L19.0446 13.1338L18.9283 13.3635L18.9452 13.011ZM18.2327 13.1535C18.2364 13.1544 18.2336 13.2191 18.2186 13.25C18.213 13.2613 18.2027 13.2735 18.1943 13.2744C18.1858 13.2754 18.1821 13.266 18.1868 13.2416C18.1914 13.2172 18.228 13.1535 18.2327 13.1535ZM18.6489 11.106L17.5521 11.721L17.4949 13.2557L18.5833 12.6144L18.6489 11.106ZM19.3718 12.6463L19.3455 13.2107L19.308 13.235L19.3333 12.6716L19.3718 12.6463ZM18.1296 13.1113C18.1343 13.1113 18.1314 13.176 18.1155 13.2079C18.1099 13.2191 18.0996 13.2313 18.0911 13.2322C18.0827 13.2332 18.0789 13.2238 18.0836 13.1994C18.0883 13.175 18.1249 13.1113 18.1296 13.1113ZM19.2752 12.8104L19.2602 13.1704L19.1627 13.0541L19.2752 12.8104ZM19.5077 12.6388L19.5021 12.7775L19.5564 12.7475L19.5499 12.9013L19.4974 12.9322L19.4955 13.0588L19.3821 12.9229L19.5077 12.6388ZM18.3049 12.9257C18.3096 12.9257 18.3068 12.9904 18.2908 13.0222C18.2852 13.0335 18.2749 13.0457 18.2664 13.0466C18.258 13.0475 18.2543 13.0382 18.2589 13.0138C18.2636 12.9894 18.3002 12.9257 18.3049 12.9257ZM19.2218 12.7082L19.1055 12.9744L19.0052 12.8385L19.2218 12.7082ZM18.3939 11.4322L18.3799 11.8185C18.3743 11.9497 18.2693 12.1879 18.1127 12.2872L18.0958 12.6519L18.3049 12.6069L17.7958 12.9013L18.0077 12.6997L18.0189 12.3416C17.883 12.4194 17.7743 12.275 17.7808 12.1288L17.793 11.7744L17.8849 11.7247L17.9149 11.8954L17.8652 11.9357L17.9749 12.2535L17.9327 11.9638L17.9702 11.9207L17.9411 11.6929L18.3939 11.4322ZM19.7252 10.5079L18.6752 11.0948L18.6096 12.6033L19.6502 11.9808L19.7252 10.5079ZM19.4514 11.8083L19.4383 11.9873L18.8233 12.3511L18.8318 12.1701L19.4514 11.8083ZM19.0164 11.0348L19.1524 11.3217L19.0502 11.3789L19.0193 12.0229L18.9218 12.0792L18.9405 11.4351L18.8421 11.4942L19.0164 11.0348ZM19.3577 10.8454L19.4899 11.1276L19.3811 11.1886L19.3586 11.8279L19.2546 11.8861L19.2874 11.242L19.1852 11.3001L19.3577 10.8454Z"
          fill="#322214"
        />
        <path
          d="M17.225 5.7035L13.5135 9.1534C13.4085 9.25372 13.3391 9.40372 13.3419 9.48153C13.3401 9.48528 13.3307 9.48809 13.3269 9.48153C13.3316 9.42153 13.2932 9.38028 13.2651 9.37371C13.2791 9.37559 13.2922 9.38028 13.296 9.36246C13.2979 9.35121 13.3007 9.33809 13.3054 9.32403C13.3091 9.31184 13.3147 9.29872 13.3213 9.28465C13.3438 9.23403 13.3804 9.1759 13.4254 9.1309L17.1687 5.63037L17.225 5.7035Z"
          fill="#D7AA77"
        />
        <path
          d="M16.4065 9.88828C16.4065 9.89859 16.4112 9.90328 16.4178 9.90047L17.5325 9.32859C17.5343 9.32765 17.5353 9.32578 17.5362 9.32203L17.5981 7.49493C17.6 7.39462 17.6562 7.29525 17.7331 7.22681L21.435 3.8999L20.3081 4.38271L16.5874 7.75378C16.4917 7.84753 16.4589 7.95815 16.4571 8.0519L16.4065 9.88828Z"
          fill="url(#paint13_linear_1690_15210)"
        />
        <path
          d="M17.225 5.70377L23.9991 2.80137L23.9578 2.74512L17.1697 5.62971L17.225 5.70377Z"
          fill="#F8CE93"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1690_15210"
          x1="342.366"
          y1="225.729"
          x2="345.853"
          y2="231.238"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1690_15210"
          x1="457.046"
          y1="186.856"
          x2="456.594"
          y2="188.075"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1690_15210"
          x1="431.49"
          y1="179.343"
          x2="490.848"
          y2="203.946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C37A44" />
          <stop offset="0.4442" stopColor="#BB713D" />
          <stop offset="0.6406" stopColor="#A05728" />
          <stop offset="1" stopColor="#964E23" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1690_15210"
          x1="663.908"
          y1="370.038"
          x2="535.149"
          y2="189.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9B880" />
          <stop offset="1" stopColor="#E4AF76" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1690_15210"
          x1="293.704"
          y1="115.652"
          x2="291.269"
          y2="108.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C37A45" stopOpacity="0" />
          <stop offset="0.1334" stopColor="#C37A45" />
          <stop offset="0.2945" stopColor="#D08D55" />
          <stop offset="0.5021" stopColor="#DEA167" />
          <stop offset="0.6966" stopColor="#E8AF73" />
          <stop offset="0.8631" stopColor="#ECB477" />
          <stop offset="1" stopColor="#ECB477" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1690_15210"
          x1="305.941"
          y1="155.484"
          x2="188.196"
          y2="426.098"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0881" stopColor="#AF6938" />
          <stop offset="0.4829" stopColor="#9A5227" />
          <stop offset="0.7792" stopColor="#8D4520" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1690_15210"
          x1="479.632"
          y1="290.458"
          x2="547.664"
          y2="168.135"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0327" stopColor="#E4AF76" />
          <stop offset="1" stopColor="#E9B880" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1690_15210"
          x1="338.229"
          y1="92.7099"
          x2="339.034"
          y2="89.1345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF6A38" stopOpacity="0" />
          <stop offset="0.086" stopColor="#AF6A38" />
          <stop offset="0.1977" stopColor="#B87542" />
          <stop offset="0.5828" stopColor="#D59C66" />
          <stop offset="0.7771" stopColor="#E4AF76" />
          <stop offset="0.9239" stopColor="#E4AF76" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1690_15210"
          x1="13.6542"
          y1="195.483"
          x2="40.8379"
          y2="195.483"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#743F1A" stopOpacity="0" />
          <stop offset="0.4929" stopColor="#743F1A" stopOpacity="0.887" />
          <stop offset="0.5" stopColor="#743F1A" stopOpacity="0.9" />
          <stop offset="0.5297" stopColor="#743F1A" stopOpacity="0.847" />
          <stop offset="1" stopColor="#743F1A" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1690_15210"
          x1="458.013"
          y1="186.802"
          x2="458.234"
          y2="186.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#322214" />
          <stop offset="0.2397" stopColor="#322314" stopOpacity="0.989" />
          <stop offset="1" stopColor="#322214" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_1690_15210"
          x1="681.275"
          y1="244.074"
          x2="673.81"
          y2="268.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0476" stopColor="#C69866" />
          <stop offset="0.4156" stopColor="#BA8C5E" />
          <stop offset="0.8135" stopColor="#B5875B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1690_15210"
          x1="332.148"
          y1="224.565"
          x2="155.205"
          y2="28.0497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#845F35" />
          <stop offset="0.4311" stopColor="#91673C" />
          <stop offset="0.4407" stopColor="#976A40" />
          <stop offset="0.8737" stopColor="#986B40" />
          <stop offset="1" stopColor="#AB8157" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_1690_15210"
          x1="346.925"
          y1="227.242"
          x2="347.346"
          y2="227.906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#322214" stopOpacity="0" />
          <stop offset="1" stopColor="#322214" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_1690_15210"
          x1="245.986"
          y1="379.723"
          x2="280.115"
          y2="207.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9794B" />
          <stop offset="0.3857" stopColor="#AE7F53" />
          <stop offset="0.4557" stopColor="#AC7D50" />
          <stop offset="0.6236" stopColor="#A9794B" />
          <stop offset="1" stopColor="#B2875D" />
        </linearGradient>
        <clipPath id="clip0_1690_15210">
          <rect width="24" height="18.0938" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
